import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PatchedClubWriteRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateClubMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.clubsCreate,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateClubMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: PatchedClubWriteRequest }) => SSF.api.clubsPartialUpdate(id, data),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteClubMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.clubsDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
